<template>
    <textarea :value="value" @input="$emit('input', $event.target.value)" :placeholder="placeholder" :rows="rows"
        :disabled="disabled" :required="required" :class="[
            'tw:w-full tw:px-4 tw:py-3 tw:text-sm tw:text-slate-700 tw:bg-white tw:border tw:border-slate-200 tw:rounded-xl tw:shadow-sm',
            'tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-brand-primary/20 tw:focus:border-brand-primary',
            'tw:transition-all tw:resize-y tw:disabled:bg-slate-100 tw:disabled:border-slate-200 tw:disabled:text-slate-400',
            customClass
        ]">
    </textarea>
</template>

<script>
export default {
    name: 'BaseTextArea',
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        rows: {
            type: [Number, String],
            default: 3
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        }
    }
}
</script>